/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */

import Vue from 'vue'
import App from './App.vue'
import linearicons from 'linearicons'
import '@/assets/styles/app.css';
import router from './router'
import VModal from 'vue-js-modal'
import CookieLaw from 'vue-cookie-law'
import Meta from 'vue-meta'


Vue.use(Meta)
Vue.use(VModal, { dialog: true })
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

window.addEventListener("dragover",function(e){
  e = e || event;
  e.preventDefault();
},false);
window.addEventListener("drop",function(e){
  e = e || event;
  e.preventDefault();
},false);

